import React from 'react';
import { Box } from '@mui/material';

export default function AmbientBackground() {
  return (
    <Box role="presentation" aria-hidden="true" sx={{
      position: 'fixed', inset: 0, width: '100%', height: '100dvh', zIndex: -1,
      overflow: 'hidden', pointerEvents: 'none',
      background: 'linear-gradient(155deg, #f5f9fe 0%, #fcfdff 38%, #f4faf6 72%, #f8f6fd 100%)',
      '&::after': {
        content: '""', position: 'absolute', inset: 0,
        backgroundImage: 'linear-gradient(rgba(58,91,120,.025) 1px, transparent 1px), linear-gradient(90deg, rgba(58,91,120,.025) 1px, transparent 1px)',
        backgroundSize: { xs: '40px 40px', md: '64px 64px' },
        maskImage: 'linear-gradient(to bottom, transparent, black 20%, transparent)',
      },
      '& .ambient-layer': { position: 'absolute', width: { xs: '150%', md: '90%' }, height: '110%', pointerEvents: 'none' },
      '@keyframes biofleetAuroraFloat': {
        '0%, 100%': { transform: 'translate3d(-4%, -4%, 0) rotate(-8deg) scale(1)', opacity: .65 },
        '50%': { transform: 'translate3d(12%, 9%, 0) rotate(10deg) scale(1.12)', opacity: 1 },
      },
      '@keyframes biofleetAuroraSweep': {
        '0%, 100%': { transform: 'translate3d(8%, 0, 0) rotate(12deg)', opacity: .7 },
        '50%': { transform: 'translate3d(-14%, -8%, 0) rotate(-10deg)', opacity: 1 },
      },
      '@media (prefers-reduced-motion: reduce)': { '& .ambient-layer': { animation: 'none' } },
      '@media (hover: none) and (pointer: coarse)': { '& .ambient-layer': { animation: 'none' } },
      '@media print': { display: 'none' },
    }}>
      <Box className="ambient-layer" sx={{ top: '-35%', left: '-25%',
        background: 'radial-gradient(ellipse, rgba(133,185,228,.12), rgba(173,209,237,.05) 35%, transparent 68%)',
        animation: 'biofleetAuroraFloat 18s ease-in-out infinite',
      }} />
      <Box className="ambient-layer" sx={{ top: '0%', right: '-30%',
        background: 'radial-gradient(ellipse, rgba(95,185,158,.13), rgba(155,217,196,.06) 35%, transparent 67%)',
        animation: 'biofleetAuroraSweep 22s ease-in-out infinite', animationDelay: '-11s',
      }} />
      <Box className="ambient-layer" sx={{ top: '40%', left: '-20%',
        background: 'radial-gradient(ellipse, rgba(159,144,207,.11), rgba(185,179,226,.05) 38%, transparent 68%)',
        animation: 'biofleetAuroraFloat 26s ease-in-out infinite', animationDelay: '-13s',
      }} />
    </Box>
  );
}
